import { useConfig } from "@jti/app-context/useConfig";
import { CasProfileApi, CasPurposesApi, getUser } from "@jti/rest-api";
import { type PurposeType } from "@jti/rest-api-types";

const checkAgeRestriction = async (): Promise<boolean> => {
  try {
    const { is_age_verified } = await CasProfileApi.init().getProfile();
    return is_age_verified;
  } catch (error) {
    console.error("Error while checking age restriction", error);
    return false;
  }
};

const checkPurposeRestriction = async (loyaltyRestrictionPurpose: string[]): Promise<PurposeType[]> => {
  try {
    const data = await CasPurposesApi.init().getPurposesForUserByCategory("all", true);

    const filteredPurposes = data
      .filter(({ id }) => loyaltyRestrictionPurpose.includes(id))
      .map(({ id, accepted }) => ({ id, accepted }));
    return filteredPurposes;
  } catch (error) {
    console.error("Error while checking purpose restriction", error);
    return [];
  }
};

export const useIsLoyaltyRestricted = () => {
  const {
    IS_LOYALTY_ENABLED,
    loyaltyRestrictionPurpose = [],
    isLoyaltyContentRestricted,
    isAgeVerifiedLoyaltyRestriction,
    isDeviceRegisteredRestriction,
  } = useConfig();

  return async (): Promise<boolean> => {
    const isLoyaltyEnabled = IS_LOYALTY_ENABLED === "true";

    if (isLoyaltyContentRestricted && isLoyaltyEnabled) {
      const isAgeVerified = isAgeVerifiedLoyaltyRestriction ? await checkAgeRestriction() : true;
      if (!isAgeVerified) return true;

      const isDeviceVerified = isDeviceRegisteredRestriction ? getUser()?.is_device_registered || false : true;
      if (!isDeviceVerified) return true;

      const isPurposeRestricted = loyaltyRestrictionPurpose.length > 0;
      const purposesStatusList = isPurposeRestricted ? await checkPurposeRestriction(loyaltyRestrictionPurpose) : [];
      const isPurposesVerified = !purposesStatusList.some(({ accepted }) => !accepted);
      if (!isPurposesVerified) return true;
    }

    return false;
  };
};
